import * as React from 'react';
import style from './IndexPageRESTView.scss';
import { SectionContainer } from '../../../SectionContainer';
import {
  IndexPageMemberView,
  MEMBER_TYPES,
} from '../IndexPageJsView/IndexPageMemberView';
import { sortMembersBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { TypeLabel } from '../../../NewSearchBox/SearchResults/TypeLabel';
import { IndexPageTagList } from './IndexPageTagList';
import { CustomLink } from '../../../PageElements/CustomLink';
import { isEmpty, hasOneTag } from '../utils';
import { Text } from '../../../PageElements/Text';

export const IndexPageRESTView = ({
  subCategories,
  operations,
  prefix,
  tags,
  mdGuides,
  mainEntity,
  webhooks,
  properties,
  clientEvents,
  node,
}) => {
  return (
    <React.Fragment>
      {!hasOneTag(node) && (
        <React.Fragment>
          {!isEmpty(mdGuides) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                title="Guides"
                subtitle="Additional information about this section"
                members={mdGuides}
                prefix={prefix}
                memberDataHook="md-guides-entry"
              />
            </SectionContainer>
          )}

          {mainEntity && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                title="Main Entity"
                subtitle="The API's main object"
                members={[mainEntity]}
                prefix={prefix}
                memberDataHook="main-entity-entry"
              />
            </SectionContainer>
          )}

          {!isEmpty(properties) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                title="Properties"
                subtitle="Store values associated with an object"
                members={sortMembersBySortOrderFirst(properties)}
                prefix={prefix}
                memberDataHook="property-entry"
              />
            </SectionContainer>
          )}

          {!isEmpty(operations) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                memberDataHook="operation-entry"
                title="Endpoints"
                type={MEMBER_TYPES.method}
                subtitle="The endpoints exposed by this API"
                members={sortMembersBySortOrderFirst(operations)}
                nameRenderer={(member, getLink, name) => {
                  return (
                    <span className={style.methodContainer}>
                      <div className={style.typeContainer}>
                        {member.docs?.request && (
                          <TypeLabel
                            withBorder={false}
                            type={member.docs?.request}
                          />
                        )}
                      </div>
                      <div className={style.nameMemberContainer}>
                        <Text link size="small" weight="normal" tagName="span">
                          <CustomLink to={getLink(member.urlFormat)}>
                            {name}
                          </CustomLink>
                        </Text>
                      </div>
                    </span>
                  );
                }}
                prefix={prefix}
              />
            </SectionContainer>
          )}

          {!isEmpty(clientEvents) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                memberDataHook="client-event-entry"
                title="Client Events"
                type={MEMBER_TYPES.clientEvents}
                subtitle="The client events exposed by this API"
                members={sortMembersBySortOrderFirst(clientEvents)}
                prefix={prefix}
              />
            </SectionContainer>
          )}

          {!isEmpty(subCategories) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                memberDataHook="sub-category-entry"
                title="APIs"
                type={MEMBER_TYPES.subCategory}
                members={subCategories}
                prefix={prefix}
                listMaxHeight="600px"
              />
            </SectionContainer>
          )}
          {webhooks && isEmpty(tags) && (
            <SectionContainer className={style.restMemberViewContainer}>
              <IndexPageMemberView
                memberDataHook="webhooks-entry"
                title="Webhooks"
                type={MEMBER_TYPES.webhooks}
                members={webhooks}
                prefix={prefix}
                listMaxHeight="600px"
              />
            </SectionContainer>
          )}
        </React.Fragment>
      )}
      {!isEmpty(tags) && <IndexPageTagList prefix={prefix} tags={tags} />}
      {hasOneTag(node) && (
        <IndexPageTagList prefix={prefix} tags={[node]} hasOneTag={true} />
      )}
    </React.Fragment>
  );
};

IndexPageRESTView.displayName = 'IndexPageRESTView';
